"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.AccordionIcon = exports.AccordionPanelWrapper = exports.CopyColumn = exports.AccordionButton = exports.AccordionTitleWrap = exports.AccordionHeading = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _Layout = require("../Layout");

var _Typography = require("../Typography");

var _Icon = _interopRequireDefault(require("../Icon"));

var _Button = _interopRequireDefault(require("../Button"));

var AccordionHeading = (0, _styled.default)(_Typography.Body)(function (_ref) {
  var _ref$theme = _ref.theme,
      accordion = _ref$theme.accordion,
      colors = _ref$theme.colors,
      mediaQueries = _ref$theme.mediaQueries,
      space = _ref$theme.space,
      selected = _ref.selected,
      isExpanded = _ref.isExpanded;
  return _defineProperty({
    backgroundColor: selected ? colors[accordion.panelBackgroundColorSelected] : colors[accordion.panelBackgroundColor],
    boxShadow: selected ? '0' : '0px 0px 3px 5px rgba(0,0,0,0.03)',
    color: selected ? colors[accordion.colorSelected] : colors[accordion.panelColor],
    borderRadius: space.xsmall,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: space.medium,
    padding: "".concat(space.small, " ").concat(space.medium),
    paddingRight: isExpanded && selected ? space.xsmall : 0,
    fontWeight: 'bold',
    cursor: 'pointer',
    userSelect: 'none'
  }, mediaQueries.medium, {
    marginBottom: space.large,
    paddingRight: 0
  });
});
exports.AccordionHeading = AccordionHeading;
var AccordionTitleWrap = (0, _styled.default)('div')(function (_ref3) {
  var _ref3$theme = _ref3.theme,
      space = _ref3$theme.space,
      mediaQueries = _ref3$theme.mediaQueries;
  return _defineProperty({
    marginBottom: space.large
  }, mediaQueries.medium, {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end'
  });
});
exports.AccordionTitleWrap = AccordionTitleWrap;
var AccordionButton = (0, _styled.default)(_Button.default)(function (_ref5) {
  var _ref5$theme = _ref5.theme,
      space = _ref5$theme.space,
      mediaQueries = _ref5$theme.mediaQueries;
  return _defineProperty({
    marginTop: space.large,
    display: 'inline-block',
    width: 'auto'
  }, mediaQueries.medium, {
    marginLeft: space.large,
    marginTop: '0'
  });
});
exports.AccordionButton = AccordionButton;
var CopyColumn = (0, _styled.default)(_Layout.Column)(function (_ref7) {
  var isLargeView = _ref7.isLargeView,
      mediaQueries = _ref7.theme.mediaQueries;
  return _defineProperty({
    visibility: isLargeView ? 'visible' : 'hidden'
  }, mediaQueries.medium, {
    minHeight: '45rem'
  });
});
exports.CopyColumn = CopyColumn;
var AccordionPanelWrapper = (0, _styled.default)('div')(function (_ref9) {
  var space = _ref9.theme.space;
  return {
    marginBottom: space.large
  };
});
exports.AccordionPanelWrapper = AccordionPanelWrapper;
var AccordionIcon = (0, _styled.default)(_Icon.default)(function () {
  return {
    position: 'relative'
  };
});
exports.AccordionIcon = AccordionIcon;